
const getIntroText = (messageData) => messageData.get('introText');
const getOutroText = (messageData) => messageData.get('outroText');
const getProctoredOutroText = (messageData) => messageData.get('proctoredOutroText');

export {getIntroText, getOutroText, getProctoredOutroText}